import { createContext } from "react";

/**
 * The `TooltipContext` value.
 */
export interface TooltipContextValue {
  /**
   * Gets the current tooltip context element.
   */
  readonly element: HTMLElement | null;
}

/**
 * The tooltip context.
 */
export const TooltipContext = createContext<TooltipContextValue>({
  element: null,
});
